module.exports = __webpack_public_path__ + "img/img_1_.bbac386e.png";